import { useCallback } from 'react'
import { loadCountries } from './CountriesStore'
import { loadCourses } from './CoursesStore'
import { loadEducationalSystems } from './EducationSystemsStore'
import { loadEducationTypes } from './EducationTypesStore'
import { loadPartnerSchoolTypes } from './PartnerSchoolTypeStore'
import { loadPrograms } from './ProgramsStore'
import { loadUniversities } from './RankedUniversitiesStore'
import { loadScholarshipFinancialSupports } from './ScholarshipsFinancialSupporsStore'
import { loadScholarshipStatuses } from './ScholarshipStatusStore'
import { loadScholarshipTypes } from './ScholarshipTypesStore'
import { loadSupplementalMaterialTypes } from './SupplementalMaterialTypesStore'
import { loadSupervisor } from './SupervisorStore'
import { loadUsersLists } from './UsersListsStore'
import { loadApplicationCertificateType } from './ApplicationCertificateTypeStore'
import { loadSupplementalMaterialRequires, useSupplementalMaterialRequires } from './SupplementalMaterialRequireStore'

export function useOptionStores() {
  const loadOptions = useCallback(async () => {
    loadEducationTypes().then()
    loadEducationalSystems().then()
    loadCourses().then()
    loadCountries().then()
    loadPartnerSchoolTypes().then()
    loadPrograms().then()
    loadScholarshipFinancialSupports().then()
    loadScholarshipStatuses().then()
    loadScholarshipTypes().then()
    loadSupplementalMaterialTypes().then()
    loadSupervisor().then()
    loadUniversities().then()
    loadUsersLists().then()
    loadApplicationCertificateType().then()
    loadSupplementalMaterialRequires().then()
  }, [])

  return { loadOptions }
}
